import React from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import clsx from 'clsx';

const CarouselIndicator = ({ selected, total, onClick }) => {
  if (total === 1) return null;

  return (
    <div className="carousel-indicator">
      {times(total, i => (
        <button
          type="button"
          key={i}
          className={clsx('carousel-indicator__item', { 'carousel-indicator__item--selected': i === selected })}
          onClick={() => onClick(i)}
          disabled={i === selected}
          tabIndex={-1}
        >
          <span className="carousel-indicator__label">{i}</span>
        </button>
      ))}
    </div>
  );
};

CarouselIndicator.propTypes = {
  selected: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

CarouselIndicator.defaultProps = {
  onClick: () => null,
};

export default CarouselIndicator;
